export default __webpack_public_path__ + "79af4232cf024bf0c1b583d37740556f.svg";